/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons'
import {
  Button,
  Image,
  DropdownButton,
  Form,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import { DraftContext } from './ContextProvider'
import ImportBtn from './ImportBtn'
import apiServices from '../services/apiServices'

function ToolBar({ setting }) {
  const {
    openRecord = () => {},
    openBoard = () => {},
    moduleKeyword = '',
    toolbarTitle = '',
    toolbarTitleDesc = '',
  } = setting
  const {
    cursor,
    history,
    handleRecover,
    showGen,
    setShowGen,
    currentID,
    regen,
    save,
    draftId,
    toExcel,
    toPDF,
  } = useContext(DraftContext)
  const showUndoRedo = true
  const [saveText, setSaveText] = useState(false)

  const location = useLocation()

  const showSaveText = () => {
    setSaveText(true)
    const timer = setTimeout(() => {
      setSaveText(false)
    }, 3000)
    return () => clearTimeout(timer)
  }

  useEffect(() => {
    showSaveText()
  }, [])

  const checkRegene = async () => {
    const res = await apiServices.data({
      path: `draft/checkq?currentId=${currentID}&draft_id=${draftId}`,
      method: 'get',
    })
    if (res) {
      setShowGen({
        ...showGen,
        show: true,
        btnText: '開始生成',
        func: (keyword) => {
          // regenate current module
          regen(keyword, location.pathname)
        },
        isToolBarBtn: true,
      })
    }
  }

  useEffect(() => {
    checkRegene()
  }, [draftId, currentID])

  const [inputFocus, setInputFocus] = useState(false)
  const [keyword, setkeyword] = useState('')

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      上傳文件讓AI根據您提供的資料生成客製化內容
    </Tooltip>
  )

  const [uploading, setuploading] = useState(null)
  useEffect(() => {
    const upload = async () => {
      const formData = new FormData()
      formData.append('file', uploading)

      // const res = await fetch('/api/draft/file', {
      //   method: 'POST',
      //   headers: {
      //     Authorization: `Bearer ${yourToken}` // 如需要授權
      //   },
      //   body: formData
      // })

      const result = await apiServices.data({
        path: `draft/file`,
        method: 'post',
        data: formData,
      })

      console.log(result)

      // const result = await res.json()
      if (!result.error) {
        alert(`檔案上傳成功！內容解析如下：${JSON.stringify(result)}`)
      } else {
        alert(`檔案上傳失敗：${result.error}`)
      }
      // const getArrayBuffer = (files) =>
      //   new Promise((resolve) => {
      //     const reader = new FileReader()
      //     reader.addEventListener('load', () => {
      //       resolve(reader.result)
      //     })
      //     reader.readAsArrayBuffer(files)
      //   })
      // const files = []
      // files.push(getArrayBuffer(uploading))

      // const buffered = await Promise.all(files)
      // const arrayed = buffered.map((buffer) => ({
      //   name: uploading.name,
      //   data: Array.from(new Uint8Array(buffer)),
      // }))
      // const res = await apiServices.data({
      //   path: `draft/file`,
      //   method: 'post',
      //   data: {
      //     files: JSON.stringify(arrayed),
      //   },
      // })
      // if (!res.error) {
      //   alert(`檔案上傳成功！`)
      // } else {
      //   alert(`檔案上傳失敗：${res.error}`)
      // }
      setuploading(null)
    }
    if (uploading) upload()
  }, [uploading])

  return (
    <div
      id="editToolbar"
      className={`edit-toolbar ${inputFocus ? 'focus' : ''}`}
    >
      <Form className="toolbar-form position-relative">
        <strong className="toolbar-title">
          {toolbarTitle}
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip className="style-dark">
                <p
                  className="note-text"
                  dangerouslySetInnerHTML={{ __html: toolbarTitleDesc }}
                />
              </Tooltip>
            }
          >
            <span className="note-span border-0">
              <Image
                src="/images/svgicons/tooltip.svg"
                alt=""
                className="img-fluid"
              />
            </span>
          </OverlayTrigger>
        </strong>
        <div className="form-control-wrap">
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
          >
            <Form.Label className="mb-0 file-input" htmlFor="file">
              <div
                className="svgIcon"
                style={{
                  maskImage: `url('/images/svgicons/keyword.svg')`,
                }}
              >
                keyword
              </div>
            </Form.Label>
          </OverlayTrigger>
          <Form.Control
            type="file"
            id="file"
            name="file"
            defaultValue={null}
            className="d-none"
            onChange={async (e) => {
              console.log(e.target.files[0])
              setuploading(e.target.files[0])
            }}
          />
          <Form.Control
            id="keyword"
            name="keyword"
            type="text"
            placeholder={
              currentID === 1 || currentID === 2
                ? '我想分析 [市場] 的 [產業/服務]'
                : '經常 [描述行為特徵] 的 [角色/職業]，想要 [達成什麼目標/任務]'
            }
            className="border-0 flex-1 mx-0 bg-white"
            aria-label="keyword"
            defaultValue={moduleKeyword}
            onFocus={() => {
              setInputFocus(true)
            }}
            onBlur={() => {
              setInputFocus(false)
            }}
            onChange={(e) => setkeyword(e.target.value)}
          />
          <Button
            className="btn-regen"
            onClick={() => {
              regen(keyword, location.pathname)
              setkeyword('')
            }}
          >
            <span className="regen-text">重新生成</span>
            <span
              className="svgIcon"
              style={{
                maskImage: `url('/images/svgicons/generate.svg')`,
              }}
            >
              重新生成
            </span>
          </Button>
        </div>
        <Button
          className="btn-primary"
          style={{
            whiteSpace: 'nowrap',
          }}
          onClick={() => {
            showSaveText()
            save()
          }}
        >
          <FontAwesomeIcon
            icon={faFloppyDisk}
            style={{
              transform: 'translateY(1px)',
              marginRight: '1rem',
            }}
          />
          儲存
        </Button>
        <div
          className={`position-absolute d-flex w-100 ${
            saveText ? 'show' : ''
          } saveText text-nowrap`}
          style={{
            pointerEvents: saveText ? '' : 'none',
          }}
        >
          <span className="toolbar-text">
            最後儲存時間{moment().format('yyyy年M月DD日 下午HH:mm')}
          </span>
        </div>
      </Form>
      <div className="d-flex justify-content-end align-items-center">
        {showUndoRedo && (
          <div className="module-setting control-bar">
            <ul className="toggle-wrap-nav nav-hor">
              <li>
                <Button
                  disabled={!cursor || history.length < 2}
                  className="btn-text"
                  onClick={() =>
                    handleRecover(
                      cursor !== -1 ? cursor - 1 : history.length - 2
                    )
                  }
                >
                  <Image src="/images/svgicons/undo.svg" alt="" />
                  UNDO
                </Button>
              </li>
              <li>
                <Button
                  className="btn-text"
                  disabled={cursor === history.length - 1 || cursor === -1}
                  onClick={() => handleRecover(cursor + 1)}
                >
                  <Image src="/images/svgicons/redo.svg" alt="" />
                  REDO
                </Button>
              </li>
            </ul>
          </div>
        )}
        <div className="module-setting">
          <DropdownButton
            title={
              <div
                className="align-items-center d-flex"
                style={{ height: '30px' }}
              >
                <div
                  className="svgIcon settingIcon bg-primary"
                  style={{
                    maskImage: `url('/images/svgicons/setting.svg')`,
                  }}
                >
                  設定
                </div>
              </div>
            }
          >
            <div className="toggle-wrap shadow-block">
              <div className="toggle-btn toggle-btn1">
                <Button className="btn-text" onClick={() => toExcel()}>
                  <div
                    className="svgIcon"
                    style={{
                      maskImage: `url('/images/svgicons/xlsx.svg')`,
                      transform: 'translateY(1px)',
                    }}
                  >
                    xlsx
                  </div>
                  匯出 xlsx
                </Button>
              </div>
              <div className="toggle-btn toggle-btn2">
                <Button className="btn-text" onClick={toPDF}>
                  <div
                    className="svgIcon"
                    style={{
                      maskImage: `url('/images/svgicons/pdf.svg')`,
                      transform: 'translateY(1px)',
                    }}
                  >
                    pdf
                  </div>
                  匯出 pdf
                </Button>
              </div>
              <div className="toggle-btn toggle-btn3">
                <ImportBtn
                  setting={{
                    className: 'btn-text',
                    currentID,
                  }}
                />
              </div>
              <div className="toggle-btn">
                <Button className="btn-text" onClick={() => openRecord()}>
                  <Image src="/images/svgicons/clock.svg" alt="" />
                  版本紀錄
                </Button>
              </div>
            </div>
          </DropdownButton>
        </div>
        <div className="module-setting">
          <Button
            className="btn-primary"
            onClick={() => {
              openBoard()
            }}
          >
            <Image src="/images/svgicons/board.svg" className="mx-3" alt="" />
            <span>更換模板</span>
          </Button>
        </div>
      </div>
    </div>
  )
}

ToolBar.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default ToolBar
